module.exports = __webpack_public_path__ + "static/studies-1309812073.0a797895.jpg";